import { createAction } from 'redux-act';
/* add addLeaveType action*/
const addLeaveTypeRequest = createAction('ADD_LEAVE_TYPE_REQUEST', data => data);
const addLeaveTypeSuccess = createAction('ADD_LEAVE_TYPE_SUCCESS', data => data);
const addLeaveTypeError = createAction('ADD_LEAVE_TYPE_ERROR');

/* Get LeaveType action */
const getAllLeaveTypesRequest = createAction('GET_ALL_LEAVE_TYPES_REQUEST', data => data);
const getAllLeaveTypesSuccess = createAction('GET_ALL_LEAVE_TYPES_SUCCESS', data => data);
const getAllLeaveTypesError = createAction('GET_ALL_LEAVE_TYPES_ERROR');

/* Update LeaveType action */
const updateLeaveTypeRequest = createAction('UPDATE_LEAVE_TYPE_REQUEST', data => data);
const updateLeaveTypeSuccess = createAction('UPDATE_LEAVE_TYPE_SUCCESS', data => data);
const updateLeaveTypeError = createAction('UPDATE_LEAVE_TYPE_ERROR');


/* Delete LeaveType action*/
const deleteLeaveTypeRequest = createAction('DELETE_LEAVE_TYPE_REQUEST', data => data);
const deleteLeaveTypeSuccess = createAction('DELETE_LEAVE_TYPE_SUCCESS', data => data);
const deleteLeaveTypeError = createAction('DELETE_LEAVE_TYPE_ERROR');

/* Get AllLeaveSetting action */
const getAllLeaveSettingRequest = createAction('GET_ALL_LEAVE_SETTING_REQUEST', data => data);
const getAllLeaveSettingSuccess = createAction('GET_ALL_LEAVE_SETTING_SUCCESS', data => data);
const getAllLeaveSettingError = createAction('GET_ALL_LEAVE_SETTING_ERROR');

/*Get LeaveSettingByLeaveId action*/
const getLeaveSettingByLeaveIdRequest = createAction('GET_LEAVE_SETTING_BY_LEAVE_ID_REQUEST', data => data);
const getLeaveSettingByLeaveIdSuccess = createAction('GET_LEAVE_SETTING_BY_LEAVE_ID_SUCCESS', data => data);
const getLeaveSettingByLeaveIdError = createAction('GET_LEAVE_SETTING_BY_LEAVE_ID_ERROR');

/* Update LeaveSetting action */
const updateLeaveSettingRequest = createAction('UPDATE_LEAVE_SETTING_REQUEST', data => data);
const updateLeaveSettingSuccess = createAction('UPDATE_LEAVE_SETTING_SUCCESS', data => data);
const updateLeaveSettingError = createAction('UPDATE_LEAVE_SETTING_ERROR');

/* Add LeaveSetting action */
const addLeaveSettingRequest = createAction('ADD_LEAVE_SETTING_REQUEST', data => data);
const addLeaveSettingSuccess = createAction('ADD_LEAVE_SETTING_SUCCESS', data => data);
const addLeaveSettingError = createAction('ADD_LEAVE_SETTING_ERROR');

/* Delete LeaveSetting action */
const deleteLeaveSettingRequest = createAction('DELETE_LEAVE_SETTING_REQUEST', data => data);
const deleteLeaveSettingSuccess = createAction('DELETE_LEAVE_SETTING_SUCCESS', data => data);
const deleteLeaveSettingError = createAction('DELETE_LEAVE_SETTING_ERROR');


/* Delete LeaveSetting action*/
const getLeaveConstantDataRequest = createAction('GET_LEAVE_CONSTANT_DATA_REQUEST', data => data);
const getLeaveConstantDataSuccess = createAction('GET_LEAVE_CONSTANT_DATA_SUCCESS', data => data);
const getLeaveConstantDataError = createAction('GET_LEAVE_CONSTANT_DATA_ERROR');

/*Get LeaveTypeList action*/
const getLeaveTypeListRequest = createAction('GET_LEAVE_TYPE_LIST_REQUEST', data => data);
const getLeaveTypeListSuccess = createAction('GET_LEAVE_TYPE_LIST_SUCCESS', data => data);
const getLeaveTypeListError = createAction('GET_LEAVE_TYPE_LIST_ERROR');

/* apply leave action*/
const applyLeaveRequest = createAction('APPLY_LEAVE_REQUEST', data => data);
const applyLeaveSuccess = createAction('APPLY_LEAVE_SUCCESS', data => data);
const applyLeaveError = createAction('APPLY_LEAVE_ERROR');

/* get All Leave action*/
const getLeaveBalanceRequest = createAction('GET_LEAVE_BALANCE_REQUEST', data => data);
const getLeaveBalanceSuccess = createAction('GET_LEAVE_BALANCE_SUCCESS', data => data);
const getLeaveBalanceError = createAction('GET_LEAVE_BALANCE_ERROR');

/*get Employee Applied Leave*/
const getEmployeeAppliedLeaveRequest = createAction('GET_EMP_APPLIED_LEAVE_REQUEST', data => data);
const getEmployeeAppliedLeaveSuccess = createAction('GET_EMP_APPLIED_LEAVE_SUCCESS', data => data);
const getEmployeeAppliedLeaveError = createAction('GET_EMP_APPLIED_LEAVE_ERROR');

/*get Employee Approvel Leave*/
const getEmployeeApprovelLeaveRequest = createAction('GET_EMP_APPROVEL_LEAVE_REQUEST', data => data);
const getEmployeeApprovelLeaveSuccess = createAction('GET_EMP_APPROVEL_LEAVE_SUCCESS', data => data);
const getEmployeeApprovelLeaveError = createAction('GET_EMP_APPROVEL_LEAVE_ERROR');

/*Approve Reject Leave*/
const approveRejectLeaveRequest = createAction('APPROVE_REJECT_LEAVE_REQUEST', data => data);
const approveRejectLeaveSuccess = createAction('APPROVE_REJECT_LEAVE_SUCCESS', data => data);
const approveRejectLeaveError = createAction('APPROVE_REJECT_LEAVE_ERROR');

/* Cancel Leave */
const cancelLeaveRequest = createAction('CANCEL_LEAVE_REQUEST', data => data);
const cancelLeaveSuccess = createAction('CANCEL_LEAVE_SUCCESS', data => data);
const cancelLeaveError = createAction('CANCEL_LEAVE_ERROR');

/*get All employee On leave in date range */
const getAllEmployeeLeaveRequest = createAction('GET_ALL_EMP_LEAVE_REQUEST', data => data);
const getAllEmployeeLeaveSuccess = createAction('GET_ALL_EMP_LEAVE_SUCCESS', data => data);
const getAllEmployeeLeaveError = createAction('GET_ALL_EMP_LEAVE_ERROR');

/*get Leave Progress*/
const getLeaveProgressRequest = createAction('GET_LEAVE_PROGRESS_REQUEST', data => data);
const getLeaveProgressSuccess = createAction('GET_LEAVE_PROGRESS_SUCCESS', data => data);
const getLeaveProgressError = createAction('GET_LEAVE_PROGRESS_ERROR');

/* check sandwich Leaves Dates*/
const sandwichLeavesDatesRequest = createAction('SANDWICH_LEAVE_REQUEST', data => data);
const sandwichLeavesDatesSuccess = createAction('SANDWICH_LEAVE_SUCCESS', data => data);
const sandwichLeavesDatesError = createAction('SANDWICH_LEAVE_ERROR');

/*Get LeaveTypeList action*/
const checkLeaveEncashmentFormulaRequest = createAction('CHECK_LEAVE_ENCASHMENT_FORMULA_REQUEST', data => data);
const checkLeaveEncashmentFormulaSuccess = createAction('CHECK_LEAVE_ENCASHMENT_FORMULA_SUCCESS', data => data);
const checkLeaveEncashmentFormulaError = createAction('CHECK_LEAVE_ENCASHMENT_FORMULA_ERROR');

/*Credit Debit Leave*/
const creditDebitLeaveRequest = createAction('CREDIT_DEBIT_LEAVE_REQUEST', data => data);
const creditDebitLeaveSuccess = createAction('CREDIT_DEBIT_LEAVE_SUCCESS', data => data);
const creditDebitLeaveError = createAction('CREDIT_DEBIT_LEAVE_ERROR');

/*Credit Debit Leave*/
const getCreditDebitLeaveRequest = createAction('GET_CREDIT_DEBIT_LEAVE_REQUEST', data => data);
const getCreditDebitLeaveSuccess = createAction('GET_CREDIT_DEBIT_LEAVE_SUCCESS', data => data);
const getCreditDebitLeaveError = createAction('GET_CREDIT_DEBIT_LEAVE_ERROR');

/* Get All  Comp Off Status Wise*/
const getCompOffDataRequest = createAction('GET_COMP_OFF_DATA_REQUEST', data => data);
const getCompOffDataSuccess = createAction('GET_COMP_OFF_DATA_SUCCESS', data => data);
const getCompOffDataError = createAction('GET_COMP_OFF_DATA_ERROR');

/* Approve Reject Comp Off */
const approveRejectCompOffRequest = createAction('APPROVE_REJECT_COMP_OFF_REQUEST', data => data);
const approveRejectCompOffSuccess = createAction('APPROVE_REJECT_COMP_OFF_SUCCESS', data => data);
const approveRejectCompOffError = createAction('APPROVE_REJECT_COMP_OFF_ERROR');

/* Approve Reject Comp Off */
const applyTourRequest = createAction('APPLY_TOUR_REQUEST', data => data);
const applyTourSuccess = createAction('APPLY_TOUR_SUCCESS', data => data);
const applyTourError = createAction('APPLY_TOUR_ERROR');

/* Get All Apply Tour Status Wise   */
const getTourDataRequest = createAction('GET_TOUR_DATA_REQUEST', data => data);
const getTourDataSuccess = createAction('GET_TOUR_DATA_SUCCESS', data => data);
const getTourDataError = createAction('GET_TOUR_DATA_ERROR');

/* Get Tours Approval Wise   */
const getTourApprovalRequest = createAction('GET_TOUR_APPROVAL_REQUEST', data => data);
const getTourApprovalSuccess = createAction('GET_TOUR_APPROVAL_SUCCESS', data => data);
const getTourApprovalError = createAction('GET_TOUR_APPROVAL_ERROR');

/* Approve Reject Tour  */
const approveRejectTourRequest = createAction('APPROVE_REJECT_TOUR_REQUEST', data => data);
const approveRejectTourSuccess = createAction('APPROVE_REJECT_TOUR_SUCCESS', data => data);
const approveRejectTourError = createAction('APPROVE_REJECT_TOUR_ERROR');

/* Get Leave Today  */
const getLeaveTodayRequest = createAction('GET_LEAVE_TODAY_REQUEST', data => data);
const getLeaveTodaySuccess = createAction('GET_LEAVE_TODAY_SUCCESS', data => data);
const getLeaveTodayError = createAction('GET_LEAVE_TODAY_ERROR');

/* Get Employee Leave  */
const getEmployeeLeaveRequest = createAction('GET_EMPLOYEE_LEAVE_REQUEST', data => data);
const getEmployeeLeaveSuccess = createAction('GET_EMPLOYEE_LEAVE_SUCCESS', data => data);
const getEmployeeLeaveError = createAction('GET_EMPLOYEE_LEAVE_ERROR');

/* Get Leave Ledger */
const getLeaveLedgerRequest = createAction('GET_LEAVE_LEDGER_REQUEST', data => data);
const getLeaveLedgerSuccess = createAction('GET_LEAVE_LEDGER_SUCCESS', data => data);
const getLeaveLedgerError = createAction('GET_LEAVE_LEDGER_ERROR');

/* Get Leave Ledger Report*/
const getLeaveLedgerReportRequest = createAction('GET_LEAVE_LEDGER_REPORT_REQUEST', data => data);
const getLeaveLedgerReportSuccess = createAction('GET_LEAVE_LEDGER_REPORT_SUCCESS', data => data);
const getLeaveLedgerReportError = createAction('GET_LEAVE_LEDGER_REPORT_ERROR');

/* clear existing Department action*/
const handleClearLeaveStore = createAction('HANDLE_CLEAR_LEAVE_STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addLeaveTypeRequest,
    addLeaveTypeSuccess,
    addLeaveTypeError,

    getAllLeaveTypesRequest,
    getAllLeaveTypesSuccess,
    getAllLeaveTypesError,

    updateLeaveTypeRequest,
    updateLeaveTypeSuccess,
    updateLeaveTypeError,

    deleteLeaveTypeRequest,
    deleteLeaveTypeSuccess,
    deleteLeaveTypeError,

    addLeaveSettingRequest,
    addLeaveSettingSuccess,
    addLeaveSettingError,

    getAllLeaveSettingRequest,
    getAllLeaveSettingSuccess,
    getAllLeaveSettingError,

    getLeaveSettingByLeaveIdRequest,
    getLeaveSettingByLeaveIdSuccess,
    getLeaveSettingByLeaveIdError,

    updateLeaveSettingRequest,
    updateLeaveSettingSuccess,
    updateLeaveSettingError,

    deleteLeaveSettingRequest,
    deleteLeaveSettingSuccess,
    deleteLeaveSettingError,

    getLeaveConstantDataRequest,
    getLeaveConstantDataSuccess,
    getLeaveConstantDataError,

    getLeaveTypeListRequest,
    getLeaveTypeListSuccess,
    getLeaveTypeListError,

    applyLeaveRequest,
    applyLeaveSuccess,
    applyLeaveError,

    getLeaveBalanceRequest,
    getLeaveBalanceSuccess,
    getLeaveBalanceError,

    getEmployeeAppliedLeaveRequest,
    getEmployeeAppliedLeaveSuccess,
    getEmployeeAppliedLeaveError,

    approveRejectLeaveRequest,
    approveRejectLeaveSuccess,
    approveRejectLeaveError,

    cancelLeaveRequest,
    cancelLeaveSuccess,
    cancelLeaveError,

    getEmployeeApprovelLeaveRequest,
    getEmployeeApprovelLeaveSuccess,
    getEmployeeApprovelLeaveError,

    getAllEmployeeLeaveRequest,
    getAllEmployeeLeaveSuccess,
    getAllEmployeeLeaveError,

    getLeaveProgressRequest,
    getLeaveProgressSuccess,
    getLeaveProgressError,

    sandwichLeavesDatesRequest,
    sandwichLeavesDatesSuccess,
    sandwichLeavesDatesError,

    checkLeaveEncashmentFormulaRequest,
    checkLeaveEncashmentFormulaSuccess,
    checkLeaveEncashmentFormulaError,

    creditDebitLeaveRequest,
    creditDebitLeaveSuccess,
    creditDebitLeaveError,

    getCreditDebitLeaveRequest,
    getCreditDebitLeaveSuccess,
    getCreditDebitLeaveError,

    getCompOffDataRequest,
    getCompOffDataSuccess,
    getCompOffDataError,

    approveRejectCompOffRequest,
    approveRejectCompOffSuccess,
    approveRejectCompOffError,

    applyTourRequest,
    applyTourSuccess,
    applyTourError,

    getTourDataRequest,
    getTourDataSuccess,
    getTourDataError,

    getTourApprovalRequest,
    getTourApprovalSuccess,
    getTourApprovalError,

    approveRejectTourRequest,
    approveRejectTourSuccess,
    approveRejectTourError,

    getLeaveTodayRequest,
    getLeaveTodaySuccess,
    getLeaveTodayError,

    getEmployeeLeaveRequest,
    getEmployeeLeaveSuccess,
    getEmployeeLeaveError,

    getLeaveLedgerRequest,
    getLeaveLedgerSuccess,
    getLeaveLedgerError,

    getLeaveLedgerReportRequest,
    getLeaveLedgerReportSuccess,
    getLeaveLedgerReportError,

    handleClearLeaveStore,
    // toastMsgAction,

}